"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headTagTitleWithAnchor = exports.headTagTitle = void 0;
var _react = _interopRequireDefault(require("react"));
var _richTextField = require("./richTextField");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var headTagTitle = (title, cssClass, Tag) => {
  if ((0, _lodash.isEmpty)(Tag)) Tag = 'h4';
  return /*#__PURE__*/_react.default.createElement(Tag, {
    className: cssClass
  }, (0, _richTextField.parseHTML)(title));
};
exports.headTagTitle = headTagTitle;
var headTagTitleWithAnchor = exports.headTagTitleWithAnchor = function headTagTitleWithAnchor(title, cssClass, Tag, linkUrl, linkTarget, linkAlt) {
  var linkCssClass = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
  var schema = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  if ((0, _lodash.isEmpty)(Tag)) Tag = 'h4';
  if ((0, _lodash.isNil)(linkCssClass)) {
    if (schema) {
      return /*#__PURE__*/_react.default.createElement(Tag, {
        className: cssClass
      }, /*#__PURE__*/_react.default.createElement("a", {
        itemprop: "name",
        style: {
          font: 'inherit'
        },
        href: linkUrl,
        target: linkTarget,
        title: linkAlt
      }, (0, _richTextField.parseHTML)(title)));
    } else {
      return /*#__PURE__*/_react.default.createElement(Tag, {
        className: cssClass
      }, /*#__PURE__*/_react.default.createElement("a", {
        style: {
          font: 'inherit'
        },
        href: linkUrl,
        target: linkTarget,
        title: linkAlt
      }, (0, _richTextField.parseHTML)(title)));
    }
  } else {
    if (schema) {
      return /*#__PURE__*/_react.default.createElement(Tag, {
        className: cssClass
      }, /*#__PURE__*/_react.default.createElement("a", {
        itemprop: "name",
        className: linkCssClass,
        href: linkUrl,
        target: linkTarget,
        title: linkAlt
      }, (0, _richTextField.parseHTML)(title)));
    } else {
      return /*#__PURE__*/_react.default.createElement(Tag, {
        className: cssClass
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: linkCssClass,
        href: linkUrl,
        target: linkTarget,
        title: linkAlt
      }, (0, _richTextField.parseHTML)(title)));
    }
  }
};
headTagTitle.propTypes = {
  Tag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', ''])
};
headTagTitleWithAnchor.propTypes = {
  Tag: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', ''])
};